import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Polygon } from "react-native-svg";

function CloseIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 84 84">
      <G id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="Icons" transform="translate(-100.000000, -865.000000)" fill={finalColor} fillRule="nonzero">
          <G id="close-(2)" transform="translate(100.000000, 865.000000)">
            <Polygon
              id="Path"
              points="84 8.46 75.54 0 42 33.54 8.46 0 0 8.46 33.54 42 0 75.54 8.46 84 42 50.46 75.54 84 84 75.54 50.46 42"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default CloseIcon;
